import { TextInput } from 'grommet';
import type { CategoryProps } from '@customTypes/types';

export const Category = (props: CategoryProps): JSX.Element => {
  return (
    <TextInput
      id="category"
      name="category"
      placeholder="Category"
      value={props.categoryName}
      hidden
      aria-hidden
    />
  );
};
